import React from 'react'
import { config } from '../Config/config'   
export default class DoctorProfiles extends React.Component {
    onLogout = () => {
        localStorage.clear()
        window.location = '/'
    }

    render() {
        const {treatment,spesialis,riwayat} = this.props
        return (
            <div>
                <div class="content">
                
                <div class="row">
                    <div class="col-sm-7 col-6">
                        <h4 class="page-title">My Profile</h4>
                    </div>

                    <div class="col-sm-5 col-6 text-right m-b-30">
                        <a href="edit-profile.html" class="btn btn-primary btn-rounded"><i class="fa fa-plus" ></i> Edit Profile</a>
                    </div>
                </div>
                <div class = "row">
                <div class="col-md-4" >
                <div class= "col-md-2" style = {{margin: "0 0 0 180px"}}>
                    <a href="edit-profile.html" class="btn btn-primary edit-btn" style = {{margin: "0 0 0 0px"}}><i class="fa fa-pencil" style = {{color:"white"}}></i></a>
                    </div>
                    <div class = "col-md-2" style = {{margin:"0 0 0 40px"}}>
                    <div class="profile-img">
                    <a href="#"><img class="avatar" src="assets/img/doctor-03.jpg" style = {{width:"200px",height :"200px",margin: "0 0 0 -50px"}} alt="" /></a> 
                    <div class="card-box" style = {{width:"200px",margin:"10px 0 0 -50px"}}>
                    <h4>{localStorage.getItem(config.username)}</h4>
                    <h5>{spesialis}</h5>
                    <a href = "janji.html">Janji</a>
                    <br/>
                    <a href = "konsultasi.html">Obrolan/Konsultasi</a>
                    </div>
                    <div class="card-box mb-0"style = {{width:"200px",margin:"10px 0 0 -50px"}}>
                    <h3 class="card-title">
                        Tentang Saya
                    </h3>
                    <div>
                    <h5>
                    <a href="#">Tindakan Medis</a>
                    </h5>
                    {
                        treatment.map(data => {
                            return(
                            <p>-{data.name}</p>
                            )
                        })
                    }
                    </div>
                    <div>
                    <h5>
                    <a href="#">Riwayat Penidikan</a>
                    </h5>
                    {
                        riwayat.map(data => {
                            return(
                            <div>
                            <div>
                                {data.institution_name}
                            </div>
                            <div>
                                <h6>{data.major} - {data.start_year}</h6>
                            </div>
                            </div>
                            )
                        })
                    }
                    </div>
                    </div>
                    <div style = {{margin:"50px 0 0 0"}} >.</div>
                    </div>
                    </div>
                </div>
                <div class = "col-md-8" style = {{margin: "0 0 0 -190px"}}>
                <div class="profile-tabs">
					<ul class="nav nav-tabs nav-tabs-bottom">
						<li class="nav-item"><a class="nav-link show active" href="#bottom-tab2" data-toggle="tab">Tindakan</a></li>
						<li class="nav-item"><a class="nav-link show" href="#about-cont" data-toggle="tab">Aktivitas</a></li>
                        <li class="nav-item"><a class="nav-link show" href="#bottom-tab3" data-toggle="tab">Konsultasi</a></li>
                        <li class="nav-item"><a class="nav-link show" href="#bottom-tab3" data-toggle="tab">Pengaturan</a></li>
					</ul>

					<div class="tab-content">
						<div class="tab-pane show" id="about-cont">
                <div class="row">
                </div>
						</div>
						<div class="tab-pane show active" id="bottom-tab2">
							Tab content 2
						</div>
						<div class="tab-pane show" id="bottom-tab3">
							Tab content 3
						</div>
					</div>
                    </div>
				</div>
                </div>
             
				
            </div>
            </div>



        )
    }
}